import React, { Component, PropTypes } from 'react';
import {
  TextField,
  RaisedButton,
  IconButton,
  FontIcon,
  RefreshIndicator } from 'material-ui';
import R from 'ramda';

class TourplanLogIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: '',
      password: '',
      url: '',
      spinner: 'hide',
    };
    this.populateState(props);
  }

  componentWillMount() {
    const { integration, getAuth } = this.props;
    if (!integration.auth) getAuth();
  }

  componentWillReceiveProps(nextProps) {
    if (R.equals(this.props.integration, nextProps.integration)) return;
    this.populateState(nextProps);
  }

  setuserNameValue = ({ target: { value } }) => {
    this.setState({ userName: value });
  };

  setPasswordValue = ({ target: { value } }) => {
    this.setState({ password: value });
  };

  setUrlValue = ({ target: { value } }) => {
    this.setState({ url: value });
  };

  populateState(props) {
    if (props.integration.auth && !R.isEmpty(props.integration.auth)
      && !(this.state.userName || this.state.password || this.state.url)
    ) {
      // only popluate state url password and username if they are not already set
      const { user_name, password, url } = props.integration.auth;
      this.state = {
        userName: user_name,
        password,
        url,
        spinner: 'hide',
      };
    }
    if (props.integration.loginResponse) {
      if (props.integration.loginResponse === 'success') document.location.reload(true);
      else if (props.integration.loginResponse === 'starting') {
        this.setState({ spinner: 'loading' });
      } else {
        this.setState({
          spinner: 'ready',
          error: 'Invalid Username or Password',
        });
      }
    }
  }

  _login() {
    const { userName, password, url } = this.state;
    this.props.login(userName, password, url);
  }

  render() {
    if (!this.props.integration.auth) return false;
    const { titleText, subTitleText, buttonText } = (() => {
      if (this.props.type === 'login') {
        return {
          titleText: 'Setup your Tourplan integration by entering your credentials',
          subTitleText:
            'This will allow us to export your TourConnect Contracts directly into your Tourplan account',
          buttonText: 'Save',
        };
      } else if (this.props.type === 'update') {
        return {
          titleText: 'Update Your Tourplan Credentials',
          subTitleText:
            'This will allow us to export your TourConnect Contracts directly into your Tourplan account',
          buttonText: 'Update',
        };
      } else if (this.props.type === 'validate') {
        return {
          titleText: 'Update Your Tourplan Credentials',
          subTitleText:
            'The Tourplan username and password you submitted were out of date, please provide correct credentials and try again',
          buttonText: 'Save',
        };
      }
    })();
    return (
      <div
        style={{
          margin: 'auto',
          width: '80%',
          textAlign: 'center',
        }}
      >
        <div style={{ fontSize: '17px', marginBottom: '15px' }}>{titleText}</div>
        <div style={{ fontSize: '12px' }}>{subTitleText}</div>
        <TextField
          style={{ left: '25px' }}
          type="text"
          hintText="Enter Your Tourplan Url"
          value={this.state.url || ''}
          floatingLabelText="Tourplan Url"
          onChange={this.setUrlValue}
        />
        <IconButton tooltip="Please contact Tourplan to get your Url" style={{ left: '22px' }}>
          <FontIcon className="tc-icon-info" color="#00bcd4" />
        </IconButton>
        <br />

        <TextField
          ref="userName"
          type="text"
          hintText="Enter Your Tourplan Username"
          value={this.state.userName || ''}
          errorText={this.state.error}
          floatingLabelText="Tourplan Username"
          onChange={this.setuserNameValue}
        />
        <br />

        <TextField
          ref="password"
          type="password"
          hintText="Enter Your Tourplan Password"
          value={this.state.password || ''}
          errorText={this.state.error}
          floatingLabelText="Tourplan Password"
          onChange={this.setPasswordValue}
        />
        <br />
        <div style={{ position: 'relative' }}>
          <RefreshIndicator status={this.state.spinner} percentage={60} left={190} top={22} />
          <RaisedButton
            style={{ margin: '25px auto 15px' }}
            label={buttonText}
            onTouchTap={this._login.bind(this)}
            secondary
          />
        </div>
      </div>
    );
  }
}

TourplanLogIn.propTypes = {
  login: PropTypes.func,
  integration: PropTypes.object,
  type: PropTypes.string,
};

export default TourplanLogIn;



// WEBPACK FOOTER //
// ./src/app/components/integration/integration-tourplan-login.jsx